export default {
  base: {
    flex: '1 0',
    maxWidth: 280,
    minWidth: 160,
    margin: '0 40px 0 0',
    padding: 0
  },
  searchInput: {
    width: 'calc(100% - 13px)',
    height: '40px',
    margin: '0 0 20px',
    padding: '3px 12px',
    borderRadius: '6px',
    fontSize: '1.1em',
    color: '#555'
  },
  searchResults: {
    width: '100%',
    height: 'calc(100% - 70px)',
    padding: '0 10px 0 5px',
    overflowX: 'auto',
    overflowY: 'auto'
  }
}



// WEBPACK FOOTER //
// ./src/components/SideBar/styles.js